module.exports = __webpack_public_path__ + "img/ti2.44f0cc83.jpg";